module.exports = __webpack_public_path__ + "img/btn_fb.0020ac82.png";